import * as React from "react";
import type { SVGProps } from "react";
const SvgChecklistInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#checklist-info_svg__a)">
      <path d="M19 22H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1H6v14h12V6h-3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1" />
      <path d="M12 18c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1" />
      <path d="M12 13h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1M14 18h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M12 10c-.13 0-.26-.02-.38-.08q-.18-.075-.33-.21-.135-.15-.21-.33A1 1 0 0 1 11 9c0-.26.11-.52.29-.71q.15-.135.33-.21c.37-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .13-.02.26-.08.38q-.075.18-.21.33c-.19.18-.45.29-.71.29M15 7c-.55 0-1-.45-1-1 0-1.1-.9-2-2-2s-2 .9-2 2c0 .55-.45 1-1 1s-1-.45-1-1c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .55-.45 1-1 1" />
      <path d="M15 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="checklist-info_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChecklistInfo;
